import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded'
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded'
import HeadsetMicRoundedIcon from '@mui/icons-material/HeadsetMicRounded'
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded'

// Shared by the support request list (MyFeedback) and the ticket popup
// (SelectedFeedback) so a ClickUp status always reads the same in both.

// Progress steps shown on the ticket popup. `step` on a status is its index
// here; statuses without one (on-hold) are shown as a banner instead.
export const TICKET_STEPS = [
  'Received',
  'Triaged',
  'Scheduled',
  'In progress',
  'Testing',
  'Completed',
]

const STATUS_CONFIGS = {
  pending: {
    label: 'Pending',
    color: '#64748B',
    bg: 'rgba(100,116,139,0.10)',
    step: 0,
  },
  triaged: {
    label: 'Triaged',
    color: '#9e8c03',
    bg: 'rgba(160, 142, 3, 0.12)',
    step: 1,
  },
  scheduled: {
    label: 'Scheduled',
    color: '#520eb8',
    bg: 'rgba(82, 14, 184, 0.12)',
    step: 2,
  },
  inProgress: {
    label: 'In progress',
    color: '#0891B2',
    bg: 'rgba(8,145,178,0.12)',
    step: 3,
  },
  testing: {
    label: 'Testing changes',
    color: '#0891B2',
    bg: 'rgba(8,145,178,0.12)',
    step: 4,
  },
  waiting: {
    label: 'Waiting for you',
    color: '#DC2626',
    bg: 'rgba(220,38,38,0.10)',
    step: null,
  },
  closed: {
    label: 'Completed',
    color: '#16A34A',
    bg: 'rgba(22,163,74,0.10)',
    step: 5,
  },
}

export const getStatusConfig = (status = '') => {
  switch (status.toLowerCase()) {
    case 'triaged':
      return STATUS_CONFIGS.triaged
    case 'scheduled':
    case 'planned today':
    case 'selected':
      return STATUS_CONFIGS.scheduled
    case 'in progress':
    case 'blocked':
      return STATUS_CONFIGS.inProgress
    case 'rf deploy':
    case 'testing':
      return STATUS_CONFIGS.testing
    case 'on-hold':
      return STATUS_CONFIGS.waiting
    case 'closed':
      return STATUS_CONFIGS.closed
    default:
      return STATUS_CONFIGS.pending
  }
}

export const getPriorityConfig = (priority = '') => {
  switch (priority.toLowerCase()) {
    case 'urgent':
      return { label: 'Urgent', color: '#DC2626', bg: 'rgba(220,38,38,0.10)' }
    case 'high':
      return { label: 'High', color: '#EA580C', bg: 'rgba(234,88,12,0.10)' }
    case 'low':
      return { label: 'Low', color: '#64748B', bg: 'rgba(100,116,139,0.10)' }
    default:
      return { label: 'Normal', color: '#64748B', bg: 'rgba(100,116,139,0.10)' }
  }
}

export const TYPE_CONFIGS = {
  clinical: {
    label: 'Clinical safety',
    longLabel: 'Clinical safety incident',
    icon: HealthAndSafetyRoundedIcon,
    color: '#B42318',
    bg: 'rgba(180,35,24,0.10)',
  },
  bug: {
    label: 'Bug',
    longLabel: 'Bug report',
    icon: BugReportRoundedIcon,
    color: '#D4145A',
    bg: 'rgba(212,20,90,0.10)',
  },
  feature: {
    label: 'Feature',
    longLabel: 'Feature request',
    icon: TipsAndUpdatesRoundedIcon,
    color: '#16A34A',
    bg: 'rgba(22,163,74,0.10)',
  },
  support: {
    label: 'Support',
    longLabel: 'Support request',
    icon: HeadsetMicRoundedIcon,
    color: '#239AA4',
    bg: 'rgba(35,154,164,0.12)',
  },
}
export const TYPE_ORDER = ['support', 'bug', 'feature', 'clinical']

export const getTypeKey = (type = '') => {
  const value = type.toLowerCase()
  if (value.includes('clinical')) return 'clinical'
  if (value.includes('bug')) return 'bug'
  if (value.includes('feature')) return 'feature'
  return 'support'
}

export const formatTicketDate = (value) => {
  if (!value) return 'Unknown'
  const date = new Date(Number(value))
  if (Number.isNaN(date.getTime())) return 'Unknown'

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}
